// Small wrapper to call the global gtag_report_conversion helper (declared in public/index.html)
export function reportConversion(url) {
  if (typeof window === 'undefined') return false;
  const primary = window.gtag_report_conversion || window.gtagReportConversion || null;
  const secondary = window.gtag_report_conversion_secondary || null;
  let called = false;
  try {
    if (typeof primary === 'function') {
      primary(url);
      called = true;
    }
    if (typeof secondary === 'function') {
      secondary(url);
      called = true;
    }
  } catch (e) {
    // ignore errors to avoid breaking UI
  }
  return called;
}
